import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';

import AuthorizedRoute from 'routes/AuthorizedRoute';
import { SETTINGS_RESOURCES, SETTINGS_SCOPES, PAGE_NAMES } from 'constant';

import CreateRole from './submodules/create';
import CloneRole from './submodules/clone';
import EditRole from './submodules/edit';
import ListRoles from './submodules/list';

const RolesDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<AuthorizedRoute
				entity={SETTINGS_RESOURCES.role}
				actions={[SETTINGS_SCOPES[SETTINGS_RESOURCES.role].getRoles]}
				configPageName={PAGE_NAMES.settings}
				path={`${path}/list`}
				component={ListRoles}
				exact
			/>
			<AuthorizedRoute
				entity={SETTINGS_RESOURCES.role}
				actions={[SETTINGS_SCOPES[SETTINGS_RESOURCES.role].updateRole]}
				configPageName={PAGE_NAMES.settings}
				path={`${path}/edit`}
				component={EditRole}
				exact
			/>
			<AuthorizedRoute
				entity={SETTINGS_RESOURCES.role}
				actions={[SETTINGS_SCOPES[SETTINGS_RESOURCES.role].createRole]}
				configPageName={PAGE_NAMES.settings}
				path={`${path}/clone`}
				component={CloneRole}
				exact
			/>
			<AuthorizedRoute
				entity={SETTINGS_RESOURCES.role}
				actions={[SETTINGS_SCOPES[SETTINGS_RESOURCES.role].createRole]}
				configPageName={PAGE_NAMES.settings}
				path={`${path}/create`}
				component={CreateRole}
				exact
			/>
			<Redirect to={`${path}/list`} />
		</Switch>
	);
};

export default RolesDashboard;
